import React from 'react'
import { format } from 'date-fns'
import { batch, useDispatch, useSelector } from 'react-redux'
import { useLocation, useNavigate } from 'react-router-dom'
import { useAccessToken, useQueryParam, useViewport } from '@chilecompra/react-kit'
import { Breadcrumb, Breadcrumbs, Button, Card, Typography } from '@chilecompra/react-kit/components'

import routes from '../../config/settings/routes'
import CustomIframe from '../../components/Custom/Iframe'
import ProtectByFeatures from '../../components/Security/ProtectByFeatures'
import { onClearFormStepOne } from '../QuoteStepOne/QuoteStepOne.actions'
import { onClearFormStepTwo } from '../QuoteStepTwo/QuoteStepTwo.actions'
import { onClearQuoteProducts } from '../AddProductsServices/AddProductsServices.actions'
import { Grid, ImgOnboarding01, Row, Root } from './QuoteRequestPublishedSuccessfully.styles'

/**
 * The QuoteRequestPublishedSuccessfully's container.
 */
const QuoteRequestPublishedSuccessfully = () => {
  const accessToken = useAccessToken()
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const quoteCode = useQueryParam('quote')

  const { state: stateLocation } = useLocation()

  const {
    size: { isDownToMedium }
  } = useViewport()

  const {
    quote: { closeDate }
  } = useSelector(state => state.quoteStepOne)

  const clearForms = () => {
    batch(() => {
      dispatch(onClearFormStepOne())
      dispatch(onClearFormStepTwo())
      dispatch(onClearQuoteProducts())
    })
  }

  const handleGoBackSearchQuote = () => {
    clearForms()
    navigate(routes.search)
  }

  const handleGoSummary = () => {
    clearForms()
    navigate(routes.quoteSummary.replace(/:quoteId/, quoteCode))
  }

  return (
    <Root>
      <Breadcrumbs onClick={handleGoBackSearchQuote}>
        <Breadcrumb>Escritorio</Breadcrumb>
        <Breadcrumb>Compra ágil</Breadcrumb>
      </Breadcrumbs>

      <Grid container justifyContent="center">
        <Card color="blank" enableBorder margin="24px 0 0" width={isDownToMedium ? '100%' : '900px'}>
          <Row>
            <ImgOnboarding01 src="/assets/images/image-voucher-CA.png" />

            <Typography fontWeight="bold" margin="0 0 8px" variant="h4">
              Compra Ágil publicada correctamente
            </Typography>

            <Typography variant="body2">
              Puedes revisar el estado de tu publicación desde la opción Compra Ágil
            </Typography>

            <Grid container justifyContent="center" margin="16px 0 0">
              <Card color="default" width="600px">
                <Typography color="black2" fontSize="16px" fontWeight="bold" margin="0 0 8px" variant="caption">
                  ID: {quoteCode}
                </Typography>

                <Typography color="black2" margin="0 0 8px" variant="body2">
                  El proceso cerrará el {closeDate ? format(new Date(closeDate), 'dd-MM-yyyy HH:mm') : ''}
                </Typography>

                <Typography color="black2" variant="body2">
                  Recuerda gestionar tu Compra Ágil oportunamente. Luego de la fecha de cierre, tendrás{' '}
                  {stateLocation?.effectiveDays} días corridos para seleccionar a un proveedor. En caso contrario, la
                  Compra Ágil será cancelada automáticamente.
                </Typography>
              </Card>
            </Grid>
          </Row>

          <Row>
            <Button color="primary" margin="32px 0 8px" onClick={handleGoSummary}>
              Ver ficha publicada
            </Button>
          </Row>

          <Row>
            <Button onClick={handleGoBackSearchQuote} variant="text">
              Volver a Compra Ágil
            </Button>
          </Row>
        </Card>

        <ProtectByFeatures rule={features => features['enable.survey']}>
          <CustomIframe accessToken={accessToken} quoteCode={quoteCode} />
        </ProtectByFeatures>
      </Grid>
    </Root>
  )
}

export default QuoteRequestPublishedSuccessfully
